import { render } from "./ChooseAuthMethod.vue?vue&type=template&id=f5666720"
import script from "./ChooseAuthMethod.vue?vue&type=script&lang=js"
export * from "./ChooseAuthMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__